import React from "react";
import { useDrag } from "react-dnd";
import { $Typography } from "us.common/components";
import { SectionTypes } from "components/TemplateEditor/Constants";
import { ISection } from "interfaces/Templates";
import { EMPTY_SECTION } from "../../Contstants";

const { Paragraph } = $Typography;

export type DraggableSectionProps = {
  section: ISection;
  disabled?: boolean;
};

const DraggableSection: React.FC<DraggableSectionProps> = ({
  section,
  disabled,
}) => {
  const [props, drag] = useDrag({
    type:
      section.name == "Table"
        ? SectionTypes.USC_TABLE
        : SectionTypes.USC_SECTION,
    item: {
      ...section,
    },
    canDrag: () => {
      return true;
    },
  });

  return (
    <>
      {!disabled && (
        <div ref={drag} key={section.name} className="component-item mb-1">
          <div className="component-item-title py-1 px-2">
            <div className="text-icon text-muted">
              {section?.name?.substring(0, 1)?.toUpperCase()}
            </div>
            <div
              style={{ maxWidth: "170px" }}
              className="d-flex flex-fill align-items-center justify-content-between text-muted pl-2"
            >
              <Paragraph
                ellipsis={{ tooltip: true }}
                className="text-muted"
                style={{
                  marginBottom: 0,
                  whiteSpace: "normal",
                  maxWidth: "100%",
                }}
              >
                {section.name}
              </Paragraph>
            </div>
          </div>
        </div>
      )}
      {disabled && section.name == EMPTY_SECTION && (
        <div ref={drag} key={section.name} className="component-item mb-1">
          <div className="component-item-title py-1 px-2">
            <div className="text-icon text-muted">
              {section?.name?.substring(0, 1)?.toUpperCase()}
            </div>
            <div
              style={{ maxWidth: "170px" }}
              className="d-flex flex-fill align-items-center justify-content-between text-muted pl-2"
            >
              <Paragraph
                ellipsis={{ tooltip: true }}
                className="text-muted"
                style={{
                  marginBottom: 0,
                  whiteSpace: "normal",
                  maxWidth: "100%",
                }}
              >
                {section.name}
              </Paragraph>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DraggableSection;
